import styled from "styled-components";

export const EditorContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const EditorMainContainer = styled.div`
  display: flex;
  height: calc(100% - 75px);
`;

export const EditorContentContainer = styled.div`
  width: 100%;
  z-index: 10;
  min-width: 0;
`;

export const ModalContent = styled.div`
  border-radius: 12px;
  background: ${({ theme }) => (theme.name === "dark" ? "#2f2f2f" : "#fff")};
  box-shadow: 0 0 1px 0 rgba(9, 30, 66, 0.31),
    0 8px 12px 0 rgba(9, 30, 66, 0.15);
  position: relative;
  padding: 20px;
`;

export const ModalHeader = styled.div`
  font-size: 20px;
  margin-bottom: 15px;
  color: ${({ theme }) => theme.text.title};
`;

export const ModalDescription = styled.div`
  font-size: 14px;
  line-height: 1.4;
  color: ${({ theme }) => theme.text.title};
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  gap: 10px;
`;
